import $ from 'jquery';
import {showFormResponse} from '../common/json-response';

export default function() {
  const saveBtn = document.querySelector('#save-contest-url-settings');

  saveBtn?.addEventListener('click', function (e) {
    e.preventDefault();

    let fieldsData = {code: {}};

    // убираем предыдущие сообщения
    const formStatusMessages = document.querySelector('.action-status-messages');
    const fieldsStatusMessages = document.querySelectorAll('.field-action-status-messages');

    formStatusMessages.innerHTML = '';
    fieldsStatusMessages.forEach((field) => {
      field.innerHTML = '';
    });

    const contestCode = document.querySelector('[name="code"]');

    fieldsData = {
      code: contestCode?.value,
    }

    $.ajax({
      type: "POST",
      url: saveBtn.getAttribute('data-url'),
      dataType: 'json',
      data: fieldsData,
      success: function (data) {
        if (data.redirectTo?.length) {
          window.location.href = data.redirectTo;
        } else {
          showFormResponse(data);
        }

        if (data.status === 'success') {
          const urlElement = document.querySelector('.cabinet-contest-url a')
          const newUrl = 'https://конкурсы.рф/contests/' + fieldsData.code;
          urlElement.innerHTML = newUrl;
          urlElement.setAttribute('href', newUrl)
        }
      },
      error: function (data) {
        showFormResponse(data);
      },
    });
  });
}
